// ESTADOS PARA HOME
export const globalLoading = state => state.loading
export const showMensaje = state => state.showMensaje
export const globalMsj = state => state.globalMsj
export const showAlert = state => state.showAlert
export const globalMsjAlert = state => state.globalMsjAlert
